import { DocumentFileClient } from "../../../../../../../../Wrap/Api/Documents/DocumentFile";
import { ProspectDocumentFileClient } from "../../../../../../../../Wrap/Api/Documents/ProspectDocumentFile";
import { ServiceValidationError } from "../../../../../../../../Wrap/Core/DataTypes/ServiceValidation/ServiceValidationError";

export class DocumentFileAction {
    public static get(
        hierarchyId: string,
        fileName: string,
        useGenericFileName: boolean,
        documentId: number,
        taskRequestId: number,
        clAccountId: string,
        callback?: (val) => void,
        encrypt = false
    ) {
        const client = new DocumentFileClient();
        const promise = client.get(
            hierarchyId,
            fileName,
            useGenericFileName,
            documentId,
            taskRequestId,
            clAccountId,
            encrypt
        );
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });

        promise.onError((err) => {});
    }

    public static getProspectDocument(
        actorId: number,
        fileName: string,
        useGenericFileName: boolean,
        documentId: number,
        taskRequestId: number,
        callback?: (val) => void,
        encrypt = false
    ) {
        const client = new ProspectDocumentFileClient();
        const promise = client.get(actorId, documentId, taskRequestId, fileName, useGenericFileName, encrypt);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });

        promise.onError((err) => {});
    }

    public static post(hierarchyId: string, documentId: number, callback?: (val: ServiceValidationError[]) => void) {
        const client = new DocumentFileClient();
        const promise = client.post(hierarchyId, documentId);
        promise.onSuccess((result: ServiceValidationError[]) => {
            if (callback) {
                callback(result);
            }
        });

        promise.onError((err) => {});
    }
}
